<template>
  <Accordion title="Dados do Depósito">
    <div class="grid grid-cols-4 gap-3">
      <Select v-if="!routeInfo.params.id" :items="type" v-model="localValue.type" label="Tipo" required :error="localErrors.type" />
      <InputText
        :disabled="disabled"
        :class="{ 'col-span-2': routeInfo.params.id }"
        v-model="localValue.name"
        label="Nome do Depósito"
        :error="localErrors.name"
        required
        placeholder="Insira o Nome do Depósito" />
      <InputZoom
        :disabled="!!disabled"
        required
        clearable
        v-model="localValue.idSource"
        label="Veículo"
        :error="localErrors.idSource || localErrors.duplicateEntry"
        database="vehicles"
        item-text="licensePlate"
        item-value="id"
        :filter="computedFilterTeam"
        placeholder="Selecione o veículo" />
      <InputZoom disabled v-model="localValue.idBase" label="Base" :error="localErrors.idBase" database="basis" item-text="name" item-value="id" />
      <TextArea :disabled="disabled" class="col-span-4" v-model="localValue.description" label="Descrição" placeholder="Insira a descrição" :error="localErrors.description" />
    </div>
  </Accordion>
</template>

<script setup>
import { reactive, ref, watch, onMounted, computed } from 'vue'
import { get } from '@/crud'
import { useRoute, useRouter } from 'vue-router'

const router = useRoute()
const routeInfo = useRoute()

const type = [
  { label: 'Físico', value: 'physic' },
  { label: 'Equipe', value: 'team' },
  { label: 'Veículo', value: 'vehicles' },
]

const props = defineProps({
  modelValue: Object,
  error: Object,
})

const emits = defineEmits(['update:modelValue'])

const localValue = reactive(props.modelValue)
const localErrors = ref(props.error)
const completeObject = ref(null)
const warehousesExist = ref([])

const computedFilterTeam = computed(() => {
  if (warehousesExist.value && warehousesExist.value.length > 0) {
    return [
      {
        column: 'id',
        value: warehousesExist.value,
        operator: 'is not in',
      },
    ]
  }
  return false
})

const loadItem = async (route, id) => {
  const filters = [{ column: 'id', value: id, operator: '=' }]

  const query = {
    params: {
      filters,
    },
  }

  const raw = await get(route, query)
  if (raw.data.length) {
    localValue.idBase = raw.data[0]?.idBase
  }
}

const loadWarehouses = async () => {
  const filters = [{ column: 'type', operator: '=', value: 'vehicles' }]
  const query = {
    params: {
      filters,
    },
  }

  const raw = await get('warehouse', query)

  warehousesExist.value = raw.data.map((el) => el.idSource)
}

onMounted(async () => {
  if (localValue.idSource) {
    await loadItem('vehicles', localValue.idSource)
  }
  await loadWarehouses()
})

watch(
  () => localValue.idSource,
  async (newValue) => {
    localValue.idBase = null
    if (newValue) {
      await loadItem('vehicles', newValue)
      await loadWarehouses()
    }
  },
)
watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
  },
)

watch(
  () => props.error,
  (newValue) => {
    localErrors.value = newValue
  },
)

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue)
})

watch(
  () => localValue.idSource,
  async (newVal) => {
    localValue.idBase = null
    if (newVal) {
      await loadItem('vehicles', newVal)
    }
  },
)
</script>
